<template>
    <div>
      <h1 class="text-center mt-5">Processed Output</h1>
      
      <h3 class="text-center">Processed Frame</h3>
      <div class="text-center">
      <img :src="processedFrameUrl" alt="Processed frame will appear here" style="max-width:1000px;border-radius: 16px;
border: 10px solid #fff;
background: rgba(255, 255, 255, 0.90);"/>
</div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        processedFrameUrl: 'data:image/jpeg;base64,' // Initial value for the img src
      };
    },
    mounted() {
      // Fetch processed frame as soon as the component is mounted
      this.fetchProcessedFrame();
      
      // Set up interval to refresh the processed frame
      this.frameFetchInterval = setInterval(this.fetchProcessedFrame, 200);
    },
    beforeDestroy() {
      // Clear the interval when the component is destroyed to avoid memory leaks
      clearInterval(this.frameFetchInterval);
    },
    methods: {
      fetchProcessedFrame() {
        fetch('https://cellnet.mywire.org/get_processed_frame')
          .then(response => response.blob())
          .then(blob => {
            const url = URL.createObjectURL(blob);
            this.processedFrameUrl = url; // Update the img src
          })
          .catch(error => {
            console.error("Error fetching processed frame:", error);
          });
      }
    }
  };
  </script>
  
  <style scoped>
  img {
    max-width: 100%; /* Make the image responsive */
    height: auto;
    border: 1px solid #ccc; /* Optional: Add a border for clarity */
  }
  </style>
  